import React from 'react';
import PageTop from '../../../core/components/PageTop';
import Panel from '../../../core/components/Panel';
import { useSplitOrderInvoicesInit } from './pagehooks/useSplitOrderInvoicesInit';
import SplitOrderInvoicesListSearch from './search/SplitOrderInvoicesListSearch';
import SplitOrderInvoicesListTable from './table/SplitOrderInvoicesListTable';
import { useSplitOrderInvoicesStore } from './pagehooks/useSplitOrderInvoicesStore';

const PageSplitOrderInvoicesList = (): JSX.Element => {
    return (
        <>
            <PageTop
                title="Split Order Invoices"
                icon="sprite-orders-split"
            />
            <Content />
        </>
    );
};

const Content = (): JSX.Element => {
    const init = useSplitOrderInvoicesInit();
    const { navigateToDetailsPage } = useSplitOrderInvoicesStore();

    if (!init) {
        return <></>;
    }

    return (
        <div className="split-order-invoices-feature split-order-invoices-list">
            <Panel
                flexDirection="column"
                noMinHeight
            >
                <SplitOrderInvoicesListSearch />
                <SplitOrderInvoicesListTable onClick={navigateToDetailsPage} />
            </Panel>
        </div>
    );
};

export default PageSplitOrderInvoicesList;
